export const DISTRIBUTION_CENTERS_LIST_KEY = 'DISTRIBUTION_CENTERS_LIST';
export const DISTRIBUTION_CENTERS_ONE_KEY = 'DISTRIBUTION_CENTERS_ONE_KEY';
export const DISTRIBUTION_CENTER_PRODUCT_LIST_KEY = 'DISTRIBUTION_CENTER_PRODUCT_LIST_KEY';

export const DISTRIBUTION_CENTER_WAREHOUSE_LIST_KEY = 'DISTRIBUTION_CENTER_WAREHOUSE_LIST_KEY';

export const DISTRIBUTION_CENTER_REPORT_KEY = 'DISTRIBUTION_CENTER_REPORT_KEY';

export const DISTRIBUTION_CENTER_USERS_KEY = 'DISTRIBUTION_CENTER_USERS_KEY';
